import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@upmc/ims.component-library';
import { UserContext } from 'context/User/UserContext';
import { dispatchImpersonationMessage } from '../../../../../utils/misc/messages';

const SubmitButton = ({ onClick, ...props }) => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const dispatch = useDispatch();

	return (
		<Button
			variant='contained'
			onClick={
				!contextUser.userInfo.allowImpersonation &&
				contextUser.userInfo.impersonationProfile !== null
					? () =>
							dispatchImpersonationMessage(
								dispatch,
								contextUser.userInfo
							)
					: onClick
			}
			{...props}
		/>
	);
};

export { SubmitButton };
